import { render, staticRenderFns } from "./platformC.vue?vue&type=template&id=e1272e92&scoped=true&"
import script from "./platformC.vue?vue&type=script&lang=js&"
export * from "./platformC.vue?vue&type=script&lang=js&"
import style0 from "./platformC.vue?vue&type=style&index=0&id=e1272e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1272e92",
  null
  
)

export default component.exports